export default function (gas) {
  if (typeof gas !== 'number') {
    return '-'
  }
  return gas / 10 ** 18
}
